<!--template html-->
<template>
    <div class="modal fade gt-md-modal" id="group-card-inspiration" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog mt-8 max-540">
            <div class="modal-content">
                <div class="gt-md-modal-header">
                    <h2>Message Suggestions</h2>
                    <div class="gt-modal-close" data-dismiss="modal">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13" />
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1" />
                            </svg>
                    </div>
                </div>
                <!-- gt-md-modal-header -->
                <div class="gt-md-modal-content">
                    <h2 class="font-16 text-center mb-5">Copy some or all of what we have provided to use as <br />your GroupCard message.</h2>
                    <div class="row" v-if="inspirationTexts">
                        <div class="col-md-12 col-lg-12 hand-section">
                            <div class="text-box gts-textbox text-box-style anything-box1" style="margin-bottom:20px;" v-for="(item, index) in inspirationTexts">
                                <div id="suggestion-1" class="text-center">
                                    <p id="para-text-1">
                                        {{item}}
                                    </p>
                                </div>
                                <div class="m-auto w-33">
                                    <input type="button" class="theme-btn-lite mt-3" id="btn-thanks-coach" @click="insertSuggestion(index)" value="Insert Text" />
                                </div>
                            </div>
                        </div>
                        <!-- Inspiration text item -->
                    </div>
                </div>
                <!-- gt-md-modal-content -->
            </div>
        </div>
    </div>
    <!-- Inspiration text -->
</template>
<!--template html-- >
< !--script -->
<script>
    export default {
        name: 'GroupCardOptionsInspirationText',
        props: {
            inspirationTexts: Array
        },
        components: {
        },
        data: function () {

        },
        mounted: function () {

        },
        methods: {
            insertSuggestion(index) {
                this.$emit('update-inspiration', this.inspirationTexts[index])
                $("#group-card-inspiration").modal("hide")
            }
        }
    }
</script>
<!--script -->
<!--Add "scoped" attribute to limit CSS to this component only-->
<style scoped>
</style>